var _desc, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "maskTransactionSaved",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 31,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.033 1.33331H6.96634C4.17967 1.33331 1.83301 3.67998 1.83301 6.46665V25.5333C1.83301 28.32 4.17967 30.6666 6.96634 30.6666H22.3663L31.1663 21.8666V6.46665C31.1663 3.67998 28.8197 1.33331 26.033 1.33331ZM9.16634 16.7333L11.073 14.68L14.153 17.76L21.7797 10.1333L23.833 12.1866L14.2997 21.8666L9.16634 16.7333ZM20.8997 27.7333V25.5333C20.8997 22.7466 23.2463 20.4 26.033 20.4H28.233L20.8997 27.7333Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#maskTransactionSaved)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32.0001
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSaved);
export default __webpack_public_path__ + "static/media/transaction-saved.6c77fe89.svg";
export { ForwardRef as ReactComponent };